import React from 'react'

import { SvgProps } from './types'

function PushToScreenSvg({
  width,
  height,
  className,
  stroke,
  fill,
  strokeColor,
  size,
  styles,
}: SvgProps) {
  const { innerWidth } = window
  const defaultWidth = innerWidth > 1024 ? 's' : 'm'
  const sizeKey = typeof size === 'undefined' ? defaultWidth : size

  const scale = {
    xl: 3.0,
    lg: 2.5,
    m: 1.0,
    s: 0.8,
    xs: 0.5,
  }

  return (
    <svg
      className={className}
      style={{
        ...styles,
        ...{
          height: 'auto',
          transform: `scale(${scale[sizeKey]})`,
        },
      }}
      xmlns="http://www.w3.org/2000/svg"
      width={width || '48'}
      height={height || '48'}
      viewBox="0 0 18 18"
      fill={fill || 'none'}
    >
      <path
        d="M13.875 12.75H14.25C15.4926 12.75 16.5 11.7426 16.5 10.5V4.5C16.5 3.25736 15.4926 2.25 14.25 2.25H3.75C2.50736 2.25 1.5 3.25736 1.5 4.5V10.5C1.5 11.7426 2.50736 12.75 3.75 12.75H4.125M11.25 12.75L9 10.5M9 10.5L6.75 12.75M9 10.5V15.75"
        stroke={strokeColor || 'currentColor'}
        strokeWidth={stroke || 1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default PushToScreenSvg
